import { Skeleton, Stack } from "@mui/material"

const MenuSkeleton = () => {
    return (
        <Stack direction="row" spacing={3}>
            <Stack direction="row" spacing={3} flex={1}>
                <Skeleton variant="rounded" width={75} height={75} />
                <Stack flex={1} justifyContent="center">
                    <Skeleton variant="text" width={250} height={30} />
                    <Skeleton variant="text" width={50} height={30} />
                </Stack>
            </Stack>
            <Stack justifyContent="center">
                <Skeleton variant="circular" width={30} height={30} />
            </Stack>
        </Stack>
    )
}

export default MenuSkeleton;
